import "./_style.less";
import React, { useState, useEffect } from "react";
import { Row, Col, Radio } from "antd";
import PackageCard from "../package-card";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export interface Assessment {
  id: number;
  name: string;
  photo?: { url?: string };
}

interface PackageCardListProps {
  assessments: Assessment[];
  value: number | undefined;
  onClick: (id?: number) => void;
  onViewDetail: (assessment: Assessment) => void;
}

const PackageCardList: React.FC<PackageCardListProps> = ({
  assessments,
  value,
  onClick,
  onViewDetail,
}) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);

  useEffect(() => {
    const handleResize = () => {
      setPageSize(window.innerWidth <= 768 ? 6 : 8);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const total = assessments.length;
  const startIdx = (page - 1) * pageSize;
  const endIdx = startIdx + pageSize;
  const pageData = assessments;
  // const pageData = assessments.slice(startIdx, endIdx);

  return (
    <>
      <Radio.Group value={value} style={{ width: "100%" }}>
        <Row gutter={[20, 20]} style={{ width: "100%" }}>
          {pageData.map((assessment) => (
            <Col xs={12} lg={6} key={assessment.id}>
              <PackageCard
                title={assessment.name}
                image={assessment.photo?.url ?? ""}
                value={assessment.id}
                checked={assessment.id === value}
                onClick={() =>
                  onClick(assessment.id === value ? undefined : assessment.id)
                }
                onViewDetail={() => onViewDetail(assessment)}
              />
            </Col>
          ))}
        </Row>
      </Radio.Group>

      {/*<div className="custom-pagination">*/}
      {/*  <button*/}
      {/*    className={`custom-pagination-btn${page === 1 ? "" : " active"}`}*/}
      {/*    disabled={page === 1}*/}
      {/*    onClick={() => setPage(page - 1)}*/}
      {/*  >*/}
      {/*    <LeftOutlined style={{ fontSize: 16 }} />*/}
      {/*  </button>*/}
      {/*  <div className="custom-pagination-center">*/}
      {/*    {Array.from({ length: Math.ceil(total / pageSize) }, (_, i) => (*/}
      {/*      <span*/}
      {/*        key={i}*/}
      {/*        className={`custom-pagination-dot${*/}
      {/*          page === i + 1 ? " active" : ""*/}
      {/*        }`}*/}
      {/*        onClick={() => setPage(i + 1)}*/}
      {/*      />*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*  <button*/}
      {/*    className={`custom-pagination-btn${*/}
      {/*      page === Math.ceil(total / pageSize) ? "" : " active"*/}
      {/*    }`}*/}
      {/*    disabled={page === Math.ceil(total / pageSize) || total === 0}*/}
      {/*    onClick={() => setPage(page + 1)}*/}
      {/*  >*/}
      {/*    <RightOutlined style={{ fontSize: 16 }} />*/}
      {/*  </button>*/}
      {/*</div>*/}
    </>
  );
};

export default PackageCardList;
